module.exports = __webpack_public_path__ + "img/splicing_btn_skip.5a040ddb.png";